import React from 'react';
import { Route, Navigate, Outlet } from 'react-router-dom';
import { lazyWithRetry } from './lazyWithRetry';

const AdminLayout = lazyWithRetry(() => import("../layout/AdminLayout"));
const AdminHome = lazyWithRetry(() => import("../pages/AdminHome"));
const AnalyticsHub = lazyWithRetry(() => import("../pages/AnalyticsHub"));
const ManageEvents = lazyWithRetry(() => import("../pages/ManageEvents"));
const ManageEventDetail = lazyWithRetry(() => import("../pages/ManageEventDetail"));
const EventCreatePage = lazyWithRetry(() => import("../pages/EventCreatePage"));
const ManageDeals = lazyWithRetry(() => import("../pages/ManageDeals"));
const ManageDealRequests = lazyWithRetry(() => import("../pages/ManageDealRequests"));
const ManageDealDetail = lazyWithRetry(() => import("../pages/ManageDealDetail"));
const ManageVenues = lazyWithRetry(() => import("../pages/ManageVenues"));
const ManageCities = lazyWithRetry(() => import("../pages/ManageCities"));
const ManageSuggestions = lazyWithRetry(() => import("../pages/ManageSuggestions"));
const ManageLifestyleCategories = lazyWithRetry(() => import("../pages/ManageLifestyleCategories"));
const ManageTokens = lazyWithRetry(() => import("../pages/ManageTokens"));
const ManageTokenDetail = lazyWithRetry(() => import("../pages/ManageTokenDetail"));
const ManageTrendingEvents = lazyWithRetry(() => import("../pages/ManageTrendingEvents"));
const WaitlistDemand = lazyWithRetry(() => import("../pages/WaitlistDemand"));
const ManageSpinWinEvents = lazyWithRetry(() => import("../pages/ManageSpinWinEvents"));
const ManageInternships = lazyWithRetry(() => import("../components/ManageInternships"));
const ManageCommunityChats = lazyWithRetry(() => import("../pages/ManageCommunityChats"));
const AdminLandingPages = lazyWithRetry(() => import("../pages/AdminLandingPages"));
const ManagePartners = lazyWithRetry(() => import("../pages/ManagePartners"));
const PartnerDetail = lazyWithRetry(() => import("../pages/PartnerDetail"));
const AdminPartnerPlans = lazyWithRetry(() => import("../pages/AdminPartnerPlans"));
const ManageRestaurants = lazyWithRetry(() => import("../pages/ManageRestaurants"));
const ManageRecommendedPlaces = lazyWithRetry(() => import("../pages/ManageRecommendedPlaces"));
const ManageAmbassadors = lazyWithRetry(() => import("../pages/ManageAmbassadors"));
const ManageArtists = lazyWithRetry(() => import("../pages/ManageArtists"));
const AdminHousemates = lazyWithRetry(() => import("../pages/AdminHousemates"));
const AdminJobs = lazyWithRetry(() => import("../pages/AdminJobs"));
const AdminCustomers = lazyWithRetry(() => import("../pages/AdminCustomers"));
const TeamManagement = lazyWithRetry(() => import("../pages/TeamManagement"));
const TeamPermissions = lazyWithRetry(() => import("../pages/TeamPermissions"));
const UserManagement = lazyWithRetry(() => import("../pages/UserManagement"));
const MarketingDashboard = lazyWithRetry(() => import("../pages/MarketingDashboard"));
const MarketingCampaigns = lazyWithRetry(() => import("../pages/MarketingCampaigns"));
const MarketingCampaignForm = lazyWithRetry(() => import("../pages/MarketingCampaignForm"));
const MarketingCalendar = lazyWithRetry(() => import("../pages/MarketingCalendar"));
const MarketingPopups = lazyWithRetry(() => import("../pages/MarketingPopups"));
const WeeklyAgendaGenerator = lazyWithRetry(() => import("../pages/WeeklyAgendaGenerator"));
const ContentCalendar = lazyWithRetry(() => import("../pages/ContentCalendar"));
const AdminInvestors = lazyWithRetry(() => import("../pages/AdminInvestors"));
const ManagePromoters = lazyWithRetry(() => import("../pages/ManagePromoters"));
const ManageUGCPartners = lazyWithRetry(() => import("../pages/ManageUGCPartners"));
const ManageUGCCampaigns = lazyWithRetry(() => import("../pages/ManageUGCCampaigns"));
const ManageUGCCampaignDetail = lazyWithRetry(() => import("../pages/ManageUGCCampaignDetail"));
const ManageUGCSubmissions = lazyWithRetry(() => import("../pages/ManageUGCSubmissions"));
const UGCBroadcast = lazyWithRetry(() => import("../pages/UGCBroadcast"));
const UGCBroadcastCompose = lazyWithRetry(() => import("../pages/UGCBroadcastCompose"));
const ManageUGCScoring = lazyWithRetry(() => import("../pages/ManageUGCScoring"));

// Blog pages
const ManageBlogs = lazyWithRetry(() => import("../pages/ManageBlogs"));
const ManageBlogPost = lazyWithRetry(() => import("../pages/ManageBlogPost"));

// Forms pages
const ManageForms = lazyWithRetry(() => import("../pages/ManageForms"));
const FormBuilder = lazyWithRetry(() => import("../pages/FormBuilder"));
const FormResponses = lazyWithRetry(() => import("../pages/FormResponses"));

// Custom pages
const ManageCustomPages = lazyWithRetry(() => import("../pages/ManageCustomPages"));
const CustomPageForm = lazyWithRetry(() => import("../pages/CustomPageForm"));

// Support pages
const ManageSupport = lazyWithRetry(() => import("../pages/ManageSupport"));

// Event tools
const EventFactChecker = lazyWithRetry(() => import("../pages/EventFactChecker"));

// Finance pages
const AdminFinance = lazyWithRetry(() => import("../pages/AdminFinance"));

// Messaging pages
const AdminMessages = lazyWithRetry(() => import("../pages/AdminMessages"));
const AdminMessageCompose = lazyWithRetry(() => import("../pages/AdminMessageCompose"));
const AdminAISettings = lazyWithRetry(() => import("../pages/AdminAISettings"));
const MobileAppNotice = lazyWithRetry(() => import("../pages/MobileAppNotice"));
const FeatureFlags = lazyWithRetry(() => import("../pages/FeatureFlags"));
const SetupCheck = lazyWithRetry(() => import("../pages/SetupCheck"));
const SeasonalThemes = lazyWithRetry(() => import("../pages/SeasonalThemes"));
const RecruitingOutreach = lazyWithRetry(() => import("../pages/RecruitingOutreach"));
const AdminAdCampaigns = lazyWithRetry(() => import("../pages/AdminAdCampaigns"));

// Email campaign pages
const EmailCampaigns = lazyWithRetry(() => import("../pages/EmailCampaigns"));
const EmailCampaignCompose = lazyWithRetry(() => import("../pages/EmailCampaignCompose"));
const EmailCampaignAnalytics = lazyWithRetry(() => import("../pages/EmailCampaignAnalytics"));
const AICampaignReview = lazyWithRetry(() => import("../pages/AICampaignReview"));

// Email automation pages
const EmailAutomationFlows = lazyWithRetry(() => import("../pages/EmailAutomationFlows"));
const EmailAutomationCompose = lazyWithRetry(() => import("../pages/EmailAutomationCompose"));

// Push campaign pages
const PushCampaigns = lazyWithRetry(() => import("../pages/PushCampaigns"));
const PushCampaignCompose = lazyWithRetry(() => import("../pages/PushCampaignCompose"));
const PushCampaignDetail = lazyWithRetry(() => import("../pages/PushCampaignDetail"));

// WhatsApp broadcast (sends come from the Chrome extension)
const WaBroadcastAdmin = lazyWithRetry(() => import("../pages/WaBroadcastAdmin"));
const AdminAppUsers = lazyWithRetry(() => import("../pages/AdminAppUsers"));

// Focus music
const AdminFocusMusic = lazyWithRetry(() => import("../pages/AdminFocusMusic"));

// Swipe feedback questions
const AdminSwipeQuestions = lazyWithRetry(() => import("../pages/AdminSwipeQuestions"));

// Partner event submissions
const AdminEventSubmissions = lazyWithRetry(() => import("../pages/AdminEventSubmissions"));

// Sales Pipeline
const SalesPipelineBoard = lazyWithRetry(() => import("../pages/SalesPipelineBoard"));

// Instagram Hub
const InstagramHub = lazyWithRetry(() => import("../pages/InstagramHub"));

// Social analytics (Zernio)
const SocialHub = lazyWithRetry(() => import("../pages/social/SocialHub"));

// UTM Link Generator
const LinkGenerator = lazyWithRetry(() => import("../pages/LinkGenerator"));

export const AdminRoutes = () => (
  <Route key="admin" path="/admin" element={<AdminLayout><Outlet /></AdminLayout>}>
    <Route path="" element={<Navigate to="home" />} />
    <Route path="home" element={<AdminHome />} />
    <Route path="analytics" element={<AnalyticsHub />} />
    <Route path="analytics/*" element={<AnalyticsHub />} />
    <Route path="events" element={<ManageEvents />} />
    <Route path="event" element={<Navigate to="/admin/events" />} />
    <Route path="events/create" element={<EventCreatePage />} />
    <Route path="events/:id" element={<ManageEventDetail />} />
    <Route path="event/:id" element={<ManageEventDetail />} />
    <Route path="lifestyle" element={<ManageDeals />} />
    <Route path="deal-requests" element={<ManageDealRequests />} />
    <Route path="deal/:id" element={<ManageDealDetail />} />
    <Route path="venues" element={<ManageVenues />} />
    <Route path="cities" element={<ManageCities />} />
    <Route path="suggestions" element={<ManageSuggestions />} />
    <Route path="lifestyle-categories" element={<ManageLifestyleCategories />} />
    <Route path="events/:city" element={<ManageEvents />} />
    <Route path="lifestyle/:category" element={<ManageDeals />} />
    <Route path="restaurants" element={<ManageRestaurants />} />
    <Route path="recommended-places" element={<ManageRecommendedPlaces />} />
    <Route path="tokens" element={<ManageTokens />} />
    <Route path="team-management" element={<TeamManagement />} />
    <Route path="team-management/permissions" element={<TeamPermissions />} />
    <Route path="user-management" element={<UserManagement />} />
    <Route path="token/:id" element={<ManageTokenDetail />} />
    <Route path="trending-events" element={<ManageTrendingEvents />} />
    <Route path="waitlist-demand" element={<WaitlistDemand />} />
    <Route path="spin-win-events" element={<ManageSpinWinEvents />} />
    <Route path="event-fact-checker" element={<EventFactChecker />} />
    <Route path="internships" element={<ManageInternships />} />
    <Route path="community-chats" element={<ManageCommunityChats />} />
    <Route path="landing-pages" element={<AdminLandingPages />} />
    <Route path="partners" element={<ManagePartners />} />
    <Route path="partners/:id" element={<PartnerDetail />} />
    <Route path="partner-plans" element={<AdminPartnerPlans />} />
    <Route path="ambassadors" element={<ManageAmbassadors />} />
    <Route path="promoters" element={<ManagePromoters />} />
    <Route path="ugc-partners" element={<ManageUGCPartners />} />
    <Route path="ugc-campaigns" element={<ManageUGCCampaigns />} />
    <Route path="ugc-campaigns/:id" element={<ManageUGCCampaignDetail />} />
    <Route path="ugc-submissions" element={<ManageUGCSubmissions />} />
    <Route path="ugc-broadcast" element={<UGCBroadcast />} />
    <Route path="ugc-broadcast/compose" element={<UGCBroadcastCompose />} />
    <Route path="ugc-scoring" element={<ManageUGCScoring />} />
    <Route path="artists" element={<ManageArtists />} />
    <Route path="blogs" element={<ManageBlogs />} />
    <Route path="blogs/create" element={<ManageBlogPost />} />
    <Route path="blogs/:id" element={<ManageBlogPost />} />
    <Route path="forms" element={<ManageForms />} />
    <Route path="forms/create" element={<FormBuilder />} />
    <Route path="forms/:id/edit" element={<FormBuilder />} />
    <Route path="forms/:id/responses" element={<FormResponses />} />
    <Route path="custom-pages" element={<ManageCustomPages />} />
    <Route path="custom-pages/create" element={<CustomPageForm />} />
    <Route path="custom-pages/:id" element={<CustomPageForm />} />
    <Route path="support" element={<ManageSupport />} />
    <Route path="customers" element={<AdminCustomers />} />
    <Route path="app-users" element={<AdminAppUsers />} />
    <Route path="housemates" element={<AdminHousemates />} />
    <Route path="jobs" element={<AdminJobs />} />
    <Route path="marketing" element={<MarketingDashboard />} />
    <Route path="marketing/campaigns" element={<MarketingCampaigns />} />
    <Route path="marketing/campaigns/create" element={<MarketingCampaignForm />} />
    <Route path="marketing/campaigns/:id" element={<MarketingCampaignForm />} />
    <Route path="marketing/calendar" element={<MarketingCalendar />} />
    <Route path="marketing/weekly-agenda" element={<WeeklyAgendaGenerator />} />
    <Route path="content-calendar" element={<ContentCalendar />} />
    <Route path="marketing/popups" element={<MarketingPopups />} />
    <Route path="marketing/recruiting" element={<RecruitingOutreach />} />
    <Route path="marketing/ig-extension" element={<Navigate to="/admin/instagram" />} />
    <Route path="marketing/ad-campaigns" element={<Navigate to="/admin/marketing/campaigns" />} />
    <Route path="marketing/link-generator" element={<LinkGenerator />} />
    <Route path="marketing/email-campaigns" element={<EmailCampaigns />} />
    <Route path="marketing/email-campaigns/compose" element={<EmailCampaignCompose />} />
    <Route path="marketing/email-campaigns/:id/analytics" element={<EmailCampaignAnalytics />} />
    <Route path="marketing/ai-campaigns" element={<AICampaignReview />} />
    <Route path="marketing/email-automation" element={<EmailAutomationFlows />} />
    <Route path="marketing/email-automation/compose" element={<EmailAutomationCompose />} />
    <Route path="marketing/push-campaigns" element={<PushCampaigns />} />
    <Route path="marketing/push-campaigns/compose" element={<PushCampaignCompose />} />
    <Route path="marketing/push-campaigns/:id" element={<PushCampaignDetail />} />
    <Route path="wa-broadcast" element={<WaBroadcastAdmin />} />
    <Route path="marketing/analytics" element={<Navigate to="/admin/analytics/marketing" />} />
    <Route path="messages" element={<AdminMessages />} />
    <Route path="messages/compose" element={<AdminMessageCompose />} />
    <Route path="investors" element={<AdminInvestors />} />
    <Route path="finance" element={<AdminFinance />} />
    <Route path="ai-settings" element={<AdminAISettings />} />
    <Route path="mobile-app-notice" element={<MobileAppNotice />} />
    <Route path="feature-flags" element={<FeatureFlags />} />
    {/* Read-only setup audit. Deliberately not in adminNavItems, so nothing in the
        sidebar or the command palette changes. Reachable only by URL:
        /admin/setup-check */}
    <Route path="setup-check" element={<SetupCheck />} />
    <Route path="seasonal-themes" element={<SeasonalThemes />} />
    <Route path="focus-music" element={<AdminFocusMusic />} />
    <Route path="swipe-questions" element={<AdminSwipeQuestions />} />
    <Route path="events/submissions" element={<AdminEventSubmissions />} />
    <Route path="sales-pipeline" element={<SalesPipelineBoard />} />
    <Route path="instagram" element={<InstagramHub />} />
    <Route path="social" element={<SocialHub />} />
    <Route path="social/:tab" element={<SocialHub />} />
  </Route>
);
